export const DEFAULT_PREFERENCES = {
    autoFocusMode: true,
    defaultFocusMode: false,
    audioEnabled: false,
    audioVolume: 0.3,
    fontSize: "medium",
    terminalModeFont: "mono",
    // E-049/F-044 — 0 (auto-fit) so the pref default matches the E-042/E-045
    // store default instead of stomping it to 2x on station mount.
    snippetZoomDefault: 0,
    showSnippetPanel: true,
    showSessionTimer: true,
    panelSplitPosition: 40,
    batchTreePinned: false,
    preferredStepType: null,
    preferredJobTypeId: null,
    showBboxOverlays: true,
    showBboxLegend: false,
    viewerZoom: null,
    viewerFitMode: "page",
    vsAutoCenterOnFocus: true,
};
//# sourceMappingURL=preferences.js.map